// extracted by mini-css-extract-plugin
export default {"priceContent":"PriceSlider_priceContent__0m71A","limit":"PriceSlider_limit__YvxDu","button":"PriceSlider_button__X6PHu"};